module.exports = {"TXTCLI_Share_link":{"id":"TXTCLI_Share_link","defaultMessage":"Hivatkozás megosztása","track":"Share link"}}